import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

// Thunks for making async requests
export const fetchInfReqData = createAsyncThunk(
  "influencerSugRequest/fetchInfReqData",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/dm/suggested_list_of_inf_by_req_id",
        formData,
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

// Initial state with pagination
const initialSuggestedState = {
  data: [],
  pagination: {
    limit: 0,
    page: 0,
    totalItems: 0,
    totalPages: 0,
  },
};

const suggestedInfSlice = createSlice({
  name: "influencerSugRequest",
  initialState: {
    infReqData: { ...initialSuggestedState },
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInfReqData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchInfReqData.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("sdsfdsdfsgdfs ==>", action.payload);

        state.infReqData = action.payload;
      })
      .addCase(fetchInfReqData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || action.error.message;
      });
  },
});

export default suggestedInfSlice.reducer;
